/**
 * Created by Mark on 24/04/2017.
 */

import React from 'react';


export default class Panel extends React.Component {

    render(){

        var ComponentClass = this.props.component;

        return <div>
            <ComponentClass data={this.props.data} />
        </div>;
    }

};

